<template>
  <transition name="slide-fade">
    <div class="overlay w-100 absolute">
      <div @click="close" class="w-60-l w-50-m db-ns dn absolute z-2 bottom-0 top-0 overlay-width"/>
      <div class="profile z-3 fixed flex flex-column w-40-l w-50-m w-100 profile-width bg-tertiary">
        <div class="image-container relative db w-100 cover center"
             :style=" { 'background-image': 'url(' + picture + ')' }">
          <a @click="close" class="ma2 pointer z-4 fixed right-0 textColor">
            <font-awesome-icon icon="times" size="2x"/>
          </a>
          <div v-show="!loadingArtist"
               class="artist-name-container absolute flex justify-start items-center bg-primary mw-50">
            <span class="artist-name z-4 f3-ns f4 white pa2 textColor">{{ artist.name }}</span>
          </div>
          <button @click="setFollow" v-if="!loadingArtist && !isFollowed"
                  class="pointer follow-container absolute pv1 flex justify-start items-center followButton">
            <span class="z-4 f5 white pa1 flex justify-start items-end">
              {{ $t("users.follow") }}
            </span>
          </button>
          <button @click="setFollow" v-if="!loadingArtist && isFollowed"
                  class="pointer follow-container absolute pv1 flex justify-start items-center bg-primary followinButton">
            <span class="z-4 f5 white pa1 flex justify-start items-end textColor">
              {{ $t("users.following") }}
            </span>
          </button>
          <button @click.prevent="checkVote" v-show="!loadingArtist && hasTracks"
                  class="pointer vote-container absolute pv1 flex justify-start items-center bg-primary"
                  :class="{disabled: voteDisabled}" :disabled="voteDisabled" >
            <span class="z-4 f4 white pa1 flex justify-start items-end textColor">
              <font-awesome-icon v-show="!loadingVote" class="accent ph1" icon="bolt" size="1x"/>
              <clip-loader class="flex ph1" :loading="loadingVote" :color="color" :size="size"></clip-loader>
              {{ $t("vinylContest.vote") }}
              <span v-if="myVotes !== null" class="br-100 bg-accent f6 votes ml2 mb1">{{ myVotes }}</span>
            </span>
          </button>
        </div>
        <div class="data-container">
          <div class="profile-tabs bg-tertiary h-6">
            <div class="h-100 bg-tertiary flex justify-center pl1 pr1">
              <a @click="changeTab('info')" :class="{'disabled-tab': loadingArtist}"
                 class="ttu tracked dib link pa2 textColor pointer tab flex justify-center items-center">{{ $t('artists.section.info')
                }}</a>
              <a @click="changeTab('tracks')" :class="{'disabled-tab': loadingArtist}"
                 class="ttu tracked dib link pa2 textColor pointer tab flex justify-center items-center">{{ $tc('tracks.track', 2)
                }}</a>
              <a @click="changeTab('playlists')" :class="{'disabled-tab': loadingArtist}"
                 class="ttu tracked dib link pa2 textColor pointer tab flex justify-center items-center">{{ $tc('playlists.playlist', 2)
                }}</a>
              <a @click="changeTab('contact')" :class="{'disabled-tab': loadingArtist}"
                 class="ttu tracked dib link pa2 textColor pointer tab flex justify-center items-center">{{ $t('artists.section.contact')
                }}</a>
            </div>
          </div>
          <div class="profile-tab-content">
            <component v-bind:is="tab"></component>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import {mixin as onClickOutside} from 'vue-on-click-outside'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import consts from '@/consts'
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

  import ArtistInfo from './ArtistInfo.vue'
  import ArtistContact from './ArtistContact.vue'
  import ArtistTracks from './ArtistTracks.vue'
  import ArtistPlaylists from './ArtistPlaylists.vue'

  export default {
    name: 'artist-profile',
    components: {
      FontAwesomeIcon,
      ClipLoader,
      'artist-contact': ArtistContact,
      'artist-info': ArtistInfo,
      'artist-playlists': ArtistPlaylists,
      'artist-tracks': ArtistTracks
    },
    data () {
      return {
        color: '#808080',
        size: '20px',
        tab: 'artist-tracks',
        aId: null,
        followedArtistsArray: null,
        isFollowed: false
      }
    },
    mixins: [onClickOutside],
    computed: {
      picture () {
        if (this.artist.primary_picture) {
          return consts.MEDIA_BASE_URL + this.artist.path + this.artist.primary_picture
        } else {
          return '/static/assets/Img_generico_principal3.jpg'
        }
      },
      ...mapGetters('artist', [
        'artistTracks',
        'error',
        'artist'
      ]),
      ...mapGetters('user', [
        'isLoggedIn',
        'isSubscribed',
        'myVotes',
        'followedArtists'
      ]),
      loadingArtist () {
        return this.$loading.isLoading('artist getArtist')
      },
      loadingVote () {
        return this.$loading.isLoading('artist setVote')
      },
      hasTracks () {
        return this.artistTracks.length > 0
      },
      voteDisabled () {
        return this.isSubscribed && this.myVotes === null
      }
    },
    watch: {
      artist: function (newArtist, oldArtist) {
        if (this.artist) {
          this.followedArtistsArray = localStorage.getItem('followedArtists').split(',')
          if (this.followedArtistsArray.includes(this.artist.id)) {
            this.isFollowed = true
          } else {
            this.isFollowed = false
          }
        }
      }
    },
    created () {
      this.aId = localStorage.getItem('qrArtistId')
    },
    methods: {
      ...mapActions('artist', [
        'setVote',
        'getArtist',
        'closeProfile'
      ]),
      ...mapActions('user', [
        'setFollowArtist',
        'getMyFollowedArtists'
      ]),
      ...mapMutations('user', [
        'setFollowing'
      ]),
      close () {
        if (this.aId && this.aId !== null) {
          localStorage.removeItem('qrArtistId')
          this.aId = null
          this.closeProfile()
          this.tab = 'artist-tracks'
          this.$router.push({path: '/artists'})
        } else {
          history.back()
          this.closeProfile()
          this.tab = 'artist-tracks'
        }
      },
      checkVote () {
        if (!this.isLoggedIn) {
          this.$modal.show('login-modal')
        } else if (!this.isSubscribed && (this.myVotes === 0 || !this.myVotes)) {
          this.$modal.show('subscription-modal')
        } else {
          this.vote()
        }
      },
      vote () {
        this.setVote(this.artist.id).then(() => {
          this.$toasted.show(this.$t('vinylContest.success'), { type: 'success' })
        }).catch((e) => {
          this.$toasted.show(this.error.message, { type: 'error' })
        })
      },
      changeTab (tab) {
        history.replaceState({}, null, `/artists/${this.artist.id}/${tab}`)
        this.tab = 'artist-' + tab
      },
      setFollow () {
        this.setFollowArtist(this.artist.id).then((response) => {
          if (response) {
            this.getMyFollowedArtists({getIds: true})
            if (this.isFollowed === false) {
              this.isFollowed = true
              this.$toasted.show(this.$t('users.followArtist') + ' ' + this.artist.name, { type: 'success' })
            } else {
              this.isFollowed = false
              this.$toasted.show(this.$t('users.unfollowArtist') + ' ' + this.artist.name, { type: 'success' })
            }
          }
          this.getMyFollowedArtists({getIds: null}).then(items => {
            this.setFollowing(items)
          })
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .followButton {
    background: #E6007E;
    padding: 0px 0px;
    border-radius: 100px;
  }
  .followinButton {
    background: #E6007E;
    padding: 0px 0px;
    border-radius: 100px;
  }

  .overlay {
    top: 3em;
    bottom: 50px;
    left: 0;
    height: $main-height;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .profile {
    right: 0;
    height: $main-height
  }

  .image-container {
    height: 35%;
    min-height: 35%;
    background-position: center center;
  }

  .image-container::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(to top right, transparent 65%, rgba(255, 255, 255, 0.8));
  }

  .data-container {
    height: 65%;
  }

  .artist-name-container {
    max-width: 50%;
    bottom: 5%;
    left: 5%;
  }

  .vote-container {
    bottom: 5%;
    right: 5%;
    border: none;
    padding: 0px 0px;
    border-radius: 100px;
  }

  .follow-container {
    bottom: 5%;
    right: 25%;
    border: none;
  }

  .artist-name {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .profile-tabs {
    height: 8%;
  }

  .tab {
    flex-grow: 1;
    text-align: center;
    font-size: 0.6rem;
  }

  .disabled-tab {
    pointer-events: none;
    cursor: default;
  }

  .disabled {
    opacity: 0.5 !important;
    cursor: default;
  }

  .profile-tab-content {
    height: 92%;
  }

  .router-link-active, .link:hover {
    background-color: #f4f3f4;
    transition: .3s;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

  .votes {
    height: 16px;
    width: 16px;
  }

  .bg-tertiary{
    background-color: $background-color;
  }

  @media screen and (max-width: 780px) and (min-width: 300px) {
    .profile-width {
      width: 75%;
    }
    .overlay-width {
      width: 25%
    }
    .follow-container {
      right: 5%;
      bottom: 17%;
    }
    .followButton {
      padding: 0px 17px;
    }
    .followinButton {
      padding: 0px 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/artistProfile/ArtistProfile.vue